// ShimmerLoader.jsx
import React from 'react';

const ShimmerLoader = ({ columns, rows = 1, hasActions = false }) => {
  return (
    <>

      {[...Array(rows)].map((_, rowIndex) => (
        <tr 
          key={rowIndex} 
          className="animate-pulse  transition-colors duration-150 group bg-white"
        >
          {columns.map((col, colIndex) => (
            <td 
              key={colIndex} 
              className={`px-3 py-2 ${col.align === "right" ? "text-right" : "text-left"} align-top`}
            >
              <div className={`
              bg-purple-shimmer-soft-gradient rounded
                ${col.field === '' ? 'h-[100px] w-[100px]' : 'h-6'} 
                ${col.width || ''}
                ${col.field === '' ? '' : 'mt-1'} // Add slight margin for text rows
              `}></div>
            </td>
          ))}
          {hasActions && (
            <td className="px-1 w-40 flex justify-center gap-6 py-2 text-center align-top">
              <div className="h-5 w-5 bg-purple-shimmer-soft-gradient rounded-full"></div>
              <div className="h-5 w-5 bg-purple-shimmer-soft-gradient rounded-full"></div>
            </td>
          )}
        </tr>
      ))}
    </>
  );
};

export default ShimmerLoader;